"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _scrollBehavior = require("scroll-behavior");

var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StateStorage = require("./StateStorage");

var _StateStorage2 = _interopRequireDefault(_StateStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  shouldUpdateScroll: _propTypes2.default.func,
  children: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired
};

var childContextTypes = {
  scrollBehavior: _propTypes2.default.object.isRequired
};

var ScrollContext = function (_React$Component) {
  (0, _inherits3.default)(ScrollContext, _React$Component);

  function ScrollContext(props, context) {
    (0, _classCallCheck3.default)(this, ScrollContext);

    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));

    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
      var shouldUpdateScroll = _this.props.shouldUpdateScroll;

      if (!shouldUpdateScroll) {
        return true;
      }

      // Hack to allow accessing scrollBehavior._stateStorage.
      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
    };

    _this.registerElement = function (key, element, shouldUpdateScroll) {
      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
    };

    _this.unregisterElement = function (key) {
      _this.scrollBehavior.unregisterElement(key);
    };

    var history = props.history;


    _this.scrollBehavior = new _scrollBehavior2.default({
      addTransitionHook: history.listen,
      stateStorage: new _StateStorage2.default(),
      getCurrentLocation: function getCurrentLocation() {
        return _this.props.location;
      },
      shouldUpdateScroll: _this.shouldUpdateScroll
    });

    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
    return _this;
  }

  ScrollContext.prototype.getChildContext = function getChildContext() {
    return {
      scrollBehavior: this
    };
  };

  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _props = this.props,
        location = _props.location,
        history = _props.history;

    var prevLocation = prevProps.location;

    if (location === prevLocation) {
      return;
    }

    var prevRouterProps = {
      history: prevProps.history,
      location: prevProps.location

      // The "scroll-behavior" package expects the "action" to be on the location
      // object so let's copy it over.
    };location.action = history.action;
    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
  };

  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
    this.scrollBehavior.stop();
  };

  ScrollContext.prototype.getRouterProps = function getRouterProps() {
    var _props2 = this.props,
        history = _props2.history,
        location = _props2.location;

    return { history: history, location: location };
  };

  ScrollContext.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return ScrollContext;
}(_react2.default.Component);

ScrollContext.propTypes = propTypes;
ScrollContext.childContextTypes = childContextTypes;

exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-react-router-scroll/ScrollBehaviorContext.js
// module id = 259
// module chunks = 168707334958949